<template>
    <div class="calendar-component-row"
        :style="`margin-left: ${firstDate}px`"
        :class="{
            'calendar-component-row-current' : currentDay,
            'calendar-component-row-prev' : prevDay,
            'calendar-component-row-available' : !available,
            'calendar-component-row-block' : is_block
        }"
        @click="clickDate()"
    >
        <span>{{ value }}</span>
    </div>
</template>

<script>
    export default {
      mounted() {
        this.checkBlockDay()
      },
      data() {
        return {
          is_block: false
        }
      },
      props: {
        value: {
          default: 0
        },
        index: {
          default: 0
        },
        month: {
          default: false
        },
        year: {
          default: false
        },
        available: {
          default: true
        },
        times: {
          default: false
        },
        info: {
          default: false
        }
      },
      computed: {
        firstDate() {
          if(this.index === 0) {

            let year = this.year
            let month = this.month - 1
            let day = this.value

            let date = new Date(year, month, day)

            date = date.getDay()

            if(date === 0) {
              return 306
            } else if(date === 1) {
              return 5.5
            } else if(date === 2) {
              return 56
            } else if(date === 3) {
              return 106
            } else if(date === 4) {
              return 157
            } else if(date === 5) {
              return 207
            } else if(date === 6) {
              return 257
            }

            return date * 51
          } else {
            return 5.5
          }
        },
        getNextDay() {
          return this.$store.getters['survey_price/block_dates']
        },
        currentDate() {
          let current = new Date().getMonth()
          current++
          return this.month === current
        },
        currentDay() {
          let day = new Date().getDate()
          return this.currentDate? day === this.value : false
        },
        prevDay() {
          let day = new Date().getDate()
          return this.currentDate ? this.value < day : false
        }
      },
      methods: {
        async clickDate() {
          if(this.available && !this.is_block) {
            this.$emit('clickDate', {
              day: this.value,
              month: this.month,
              year: this.year,
              times: this.times,
              info: this.info
            })
          }
        },
        checkBlockDay() {
          this.is_block = false
          for(let i = 0; i < this.getNextDay.length; i++) {
            if ((this.getNextDay[i].day === this.value) && (this.getNextDay[i].month === this.month) && (this.getNextDay[i].year === Number(this.year))) {
              this.is_block = true
              break;
            }
          }
        }
      }
    }
</script>

<style lang="less">
    .calendar-component-row {
        width: 39px;
        height: 39px;
        border-radius: 100%;
        background: rgba(4, 202, 0, 0.44);
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 11px;
        margin-left: 5.5px;
        margin-right: 5.5px;
        cursor: pointer;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .calendar-component-row span {
        color: #FFFFFF;
        text-align: center;
        font-size: 14px;
        line-height: 14px;
        font-family: 'Montserrat-Medium';
        opacity: 1;
    }

    .calendar-component-row-available {
        background: rgba(255, 255, 255, 0.15);
        cursor: inherit;
    }

    .calendar-component-row-block {
      opacity: .5;
      cursor: default;
    }

    .calendar-component-row-available span {
        color: #FFFFFF;
        opacity: 1;
    }

    .calendar-component-row-current {
        background: #FFFFFF;
    }

    .calendar-component-row-current span {
        color: #31283D;
        opacity: 1;
    }

    .calendar-component-row-prev {
        background: transparent;
        cursor: inherit;
    }

    .calendar-component-row-prev span {
        color: #FFFFFF;
        opacity: .3;
    }

</style>